// Inline SVG icons (Lucide) for delivery states and consent. Never glyphs or emoji.
import type { LucideIcon } from 'lucide-react';
import { Ban, Check, CheckCheck, CircleAlert, Clock, Hourglass, Send, ShieldCheck, ShieldQuestion, ShieldX } from 'lucide-react';
import type { ConsentState, MessageState } from '../../lib/api.ts';

export const STATE_ICON: Record<MessageState, LucideIcon> = {
  queued: Clock,
  submitted: Send,
  sent: Check,
  delivered: CheckCheck,
  failed: CircleAlert,
  received: Check,
  suppressed: Ban,
};

export const CONSENT_ICON: Record<ConsentState, LucideIcon> = {
  opted_in: ShieldCheck,
  pending_confirmation: Hourglass,
  opted_out: ShieldX,
  unknown: ShieldQuestion,
};
